import { render, staticRenderFns } from "./SimpleSignFebos.vue?vue&type=template&id=a7e23570&"
import script from "./SimpleSignFebos.vue?vue&type=script&lang=js&"
export * from "./SimpleSignFebos.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSignFebos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7e23570')) {
      api.createRecord('a7e23570', component.options)
    } else {
      api.reload('a7e23570', component.options)
    }
    module.hot.accept("./SimpleSignFebos.vue?vue&type=template&id=a7e23570&", function () {
      api.rerender('a7e23570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/febos/SimpleSignFebos.vue"
export default component.exports